import { GraphQLRecommendationsRequester, type SubmitRecommendationFeedbackInput } from '@cobliteam/api-lib';
import { useMutation } from '@tanstack/react-query';
import useUser from '../useEntity/useUser';

const recommendationsRequester = new GraphQLRecommendationsRequester();

export const useCompleteAiRecommendation = () => {
  const { getSession } = useUser();
  const fleetId = getSession()?.fleet?.id;

  return useMutation({
    mutationFn: ({ journeyId, recommendationType }: { journeyId: string; recommendationType: string }) => {
      if (!fleetId) return Promise.reject(new Error('fleetId not available'));
      return recommendationsRequester.completeFleetAiRecommendation(fleetId, journeyId, recommendationType);
    },
  });
};

export const useDismissAiRecommendation = () => {
  const { getSession } = useUser();
  const fleetId = getSession()?.fleet?.id;

  return useMutation({
    mutationFn: ({ journeyId, recommendationType }: { journeyId: string; recommendationType: string }) => {
      if (!fleetId) return Promise.reject(new Error('fleetId not available'));
      return recommendationsRequester.dismissFleetAiRecommendation(fleetId, journeyId, recommendationType);
    },
  });
};

export const useSubmitRecommendationFeedback = () => {
  return useMutation({
    mutationFn: (input: SubmitRecommendationFeedbackInput) => recommendationsRequester.submitRecommendationFeedback(input),
  });
};
